import React from 'react'
const ValidationContext = React.createContext()

export {
  ValidationContext
}



// WEBPACK FOOTER //
// ./src/components/validation/validationContext.js